module.exports = __webpack_public_path__ + "img/nutrieon-advance-diazon-83x113.16c0d3fd.jpg";